import buttonShapes from "@insite/mobius/Button/buttonShapes";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import hoverAnimations from "@insite/mobius/Button/hoverAnimations";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/theme/common/mixins/transition";
import { focusStyles } from "@store/theme/common/mixins/typography";
import { css } from "styled-components";

export const buttonDisabledStyles = (buttonType: string) => {
    switch (buttonType) {
        case "solid":
            return css`
                ${({ theme }) => {
                    return css`
                        &:disabled {
                            color: ${getColor("common.disabledDark")};
                            background-color: ${getColor("common.disabledLight")};
                            border-color: ${getColor("common.disabledLight")};
                        }
                    `;
                }}
            `;
        case "outline":
            return css`
                ${({ theme }) => {
                    return css`
                        &:disabled {
                            color: ${getColor("common.disabledDark")};
                            background-color: ${getColor("common.disabledLight")};
                            border-color: ${getColor("common.disabledLight")};
                        }
                    `;
                }}
            `;
        default:
            break;
    }
};

export const buttonBaseStyles = (buttonType: string) => {
    const baseStyle = css`
        ${focusStyles()}
        height: auto;
        min-width: 125px;
        min-height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        ${transitionHoverStyles()}
    `;

    switch (buttonType) {
        case "solid":
            return css`
                ${baseStyle}
                ${buttonDisabledStyles(buttonType)}
            `;
        case "outline":
            return css`
                ${baseStyle}
                ${buttonDisabledStyles(buttonType)}
            `;
        default:
            return null;
    }
};

export interface StoreThemeButtonProps {
    variant?: string;
    type?: string;
    shape?: string;
    animation?: string;
}

export const themeButtonStyles = ({ variant = "primary", type, shape, animation }: StoreThemeButtonProps) => {
    return css`
        ${({ theme }) => {
            const _buttonVariantProps = theme.button[variant];

            if (_buttonVariantProps) {
                const _buttonTypes: any = buttonTypes;
                const _buttonShapes: any = buttonShapes;
                const _hoverAnimations: any = hoverAnimations;

                const _buttonTypeFunction =
                    (type ? _buttonTypes[type] : _buttonTypes[_buttonVariantProps.buttonType]) || null;
                const _buttonShapeFunction =
                    (shape ? _buttonShapes[shape] : _buttonShapes[_buttonVariantProps.shape]) || null;
                const _hoverAnimationFunction =
                    (animation ? _hoverAnimations[animation] : _hoverAnimations[_buttonVariantProps.hoverAnimation]) ||
                    null;

                const buttonProps = {
                    ..._buttonVariantProps,
                    _color: _buttonVariantProps.color,
                    _sizeVariant: _buttonVariantProps.sizeVariant,
                    _size: _buttonVariantProps.size,
                    _shape: _buttonVariantProps.shape,
                    theme,
                };

                return css`
                    ${_buttonTypeFunction ? _buttonTypeFunction(buttonProps) : null}
                    ${_buttonShapeFunction ? _buttonShapeFunction(buttonProps) : null}
                    ${_hoverAnimationFunction ? _hoverAnimationFunction(buttonProps) : null}
                `;
            }

            return null;
        }}
    `;
};

export const prevNextArrowButton = () => {
    return css`
        padding: 0.5em;
        height: auto;
        min-width: 40px;
        border: 0;
        border-radius: 50%;
        box-shadow: 0 0 1px 0 rgba(48, 49, 51, 0.05), 0 4px 8px 0 rgba(48, 49, 51, 0.1);
        z-index: 1;

        &:not(:disabled):hover {
            box-shadow: 0 0 1px 0 rgba(48, 49, 51, 0.05), 0 4px 8px 0 rgba(48, 49, 51, 0.3);
            transform: scale(1.2);
        }

        &:focus,
        &:active,
        &:disabled {
            background-color: ${getColor("common.background")};
        }

        &:disabled {
            opacity: 0.5;
            cursor: default;
        }
    `;
};
